import { Signal } from "signals";
import ServiceLocator from "../../ServiceLocator";
import SpecialCardAnimation from "./SpecialCardAnimation";

import * as PIXI from "pixi.js";
import gsap from "gsap";


export default class ReverseAnimation extends SpecialCardAnimation
{
    private _spinDir: number = null;

    private _iconWrapper: PIXI.Container = null;
    private _iconShadow: PIXI.Sprite = null;
    private _icon: PIXI.Sprite = null;

    private _onReversed: Signal = null;


    public set spinDir( value: number ) { this._spinDir = value; }

    public get onReversed(): Signal { return this._onReversed; }


    public constructor()
    {
        super();
    }

    public init(): void
    {
        super.init();

        console.assert( this._spinDir !== null, "ReverseAnimation.ts :: init() :: this._spinDir cannot be null." );

        this._onReversed = new Signal();

        this._bannerText.text = "REVERSE";
        this._bannerText.style.fill = this._kArrHexColor[ this._color ];

        this._iconWrapper = new PIXI.Container();
        this._iconWrapper.scale.x = -this._spinDir;
        this._iconWrapper.position.set( ServiceLocator.app.width * 0.5, ServiceLocator.app.height * 0.5 );
        this.addChild( this._iconWrapper );
        //
        this._iconShadow = new PIXI.Sprite( ServiceLocator.resources.special_icon_reverse_shadow.texture );
        this._iconShadow.anchor.set( 0.5 );
        this._iconShadow.visible = false;
        this._iconShadow.position.set( -30.5 * 0.5, 32.5 * 0.5 );
        this._iconWrapper.addChild( this._iconShadow );
        //
        this._icon = new PIXI.Sprite( ServiceLocator.resources[ "special_icon_reverse_" + [ "red", "yellow", "blue", "green" ][ this._color ] ].texture );
        this._icon.anchor.set( 0.5 );
        this._icon.visible = false;
        this._iconWrapper.addChild( this._icon );
    }

    public end(): void
    {
        this._onReversed.dispose();
        this._onReversed = null;

        super.end();

        // TODO:
    }

    /*public play(): void
    {
        this._banner.visible = true;
        this._glow.visible = true;
        this._icon.visible = true;
        this._iconShadow.visible = true;
        this._iconShadow.alpha = 0;

        this._tl = new gsap.core.Timeline();
        this._tl.from( this._banner.scale, { y: 0, duration: 0.2, ease: "sine.in" }, 0 );
        this._tl.from( this._glow, { alpha: 0, duration: 0.2, ease: "sine.in" }, "<" );
        this._tl.from( this._icon.scale, { x: 2, y: 2, duration: 0.2, ease: "linear.inOut" }, "<" );
        this._tl.from( this._iconShadow, { x: "-=60", duration: 0.2, ease: "sine.in" }, "<" );
        this._tl.to( this._iconShadow, { alpha: 1, duration: 0.2, ease: "sine.in" }, "<" );
        this._tl.to( this._icon, { angle: 360 * 6, duration: 1.4, ease: "sine.inOut" }, 0.6 );
        this._tl.to( this._iconShadow, { angle: 360 * 6, duration: 1.4, ease: "sine.inOut" }, "<" );
        this._tl.call( () => { this._onReversed.dispatch(); }, null, 0.9 );
        this._tl.to( this._iconWrapper, { alpha: 0, duration: 0.4, ease: "sine.out" }, 1.6 );
        this._tl.to( this._glow, { alpha: 0, duration: 0.2, ease: "sine.in" }, 1.8 );
        this._tl.to( this._banner.scale, { y: 0, duration: 0.2, ease: "sine.in" }, "<" );
        this._tl.call( () => { this._onCompleted.dispatch(); }, null, 2.2 );
        //
        ServiceLocator.game.tweenGroup.add( this._tl );
    }*/

    public play(): void
    {
        this._glow.visible = true;
        this._icon.visible = true;
        this._iconShadow.visible = true;
        this._iconShadow.alpha = 0;

        this._tl = new gsap.core.Timeline();
        this._tl.from( this._glow, { alpha: 0, duration: 0.2, ease: "sine.in" }, "<" );
        this._tl.from( this._icon.scale, { x: 2, y: 2, duration: 0.2, ease: "linear.inOut" }, "<" );
        this._tl.from( this._iconShadow, { x: "-=60", duration: 0.2, ease: "sine.in" }, "<" );
        this._tl.to( this._iconShadow, { alpha: 1, duration: 0.2, ease: "sine.in" }, "<" );
        this._tl.to( this._icon, { angle: -360 * 3, duration: 0.7, ease: "sine.inOut" }, 0.4 );
        this._tl.to( this._iconShadow, { angle: -360 * 3, duration: 0.7, ease: "sine.inOut" }, "<" );
        this._tl.call( () => { this._onReversed.dispatch(); }, null, 0.7 );
        this._tl.to( this._iconWrapper, { alpha: 0, duration: 0.4, ease: "sine.out" }, 0.7 );
        this._tl.to( this._glow, { alpha: 0, duration: 0.2, ease: "sine.in" }, 0.7 );
        this._tl.call( () => { this._onCompleted.dispatch(); }, null, 1.2 );
        //
        ServiceLocator.game.tweenGroup.add( this._tl );

        ServiceLocator.audio.playSfx( "reverse_special" );
    }
}